module.exports = __webpack_public_path__ + "assets/img/one4.5ddc1e04.png";